<template>
  <div>
    <h1>投入报表</h1>
  </div>
</template>
<script>
export default {
  name: 'ChartsInputs',
  data() {
    return {}
  },
  mounted() {
    console.log('【↑↑↑】', this.$options.name)
  },
  beforeDestroy() {
    console.log('【↓↓↓】', this.$options.name)
  },
}
</script>


// WEBPACK FOOTER //
// src/components/report/Inputs.vue